<template>
  <div class="milkfarm" v-if="isLoaded">
    <div class="menu">
      <TextButton @click="selectedTab='Menu'; farm.stopUpdating();"
                  class="tab menu-tab"
                  :class="{'selected-tab': selectedTab === 'Menu'}">
        <h1>Menu</h1>
      </TextButton>
      <TextButton v-for="tab in tabs" :key="tab" @click="selectTab(tab)"
                  class="tab"
                  :class="{'selected-tab': selectedTab === tab.id, 'disabled-tab': !saveSystem.hasFarm}">
        <h1>{{ tab.label }}</h1>
      </TextButton>
    </div>
    <keep-alive>
      <component :is="selectedTab" v-bind="currentProperties" v-on:close="$emit('close')"></component>
    </keep-alive>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import PastureView from '@/components/screens/PastureView.vue'
import TextButton from '@/components/ui/TextButton.vue'
import globalState from '@/store/globalState'
import { unref } from 'vue'
import Laboratory from '@/farm/Laboratory'
import Menu from '@/components/screens/Menu.vue'
import SaveSystem from '@/SaveSystem'
import LabView from "@/components/screens/LabView.vue"
import OfficeView from "@/components/screens/OfficeView.vue"
import StartMenu from "@/components/screens/StartMenu.vue"

@Options({
  components: {
    ValueMeter, PastureView, LabView, OfficeView, TextButton, Menu, StartMenu
  },
  props: {
    saveSystem: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    selectTab(tab: any) {
      if (!this.saveSystem.hasFarm) return

      if (this.selectedTab === 'Menu' && tab !== 'Menu') this.farm.startUpdating()

      this.selectedTab = tab.id
    }
  },
  computed: {
    currentProperties: function() {
      if (this.selectedTab === 'PastureView') {
        return { farm: this.farm }
      }
      if (this.selectedTab === 'LabView') {
        return { farm: this.farm }
      }
      if (this.selectedTab === 'OfficeView') {
        return { farm: this.farm }
      }
      if (this.selectedTab === 'Menu') {
        return { saveSystem: this.saveSystem }
      }
    },
    farm: function (): Farm {
      return this.saveSystem.farm
    }
  },
  async created() {
    //await globalState().load()
    //this.saveSystem = new SaveSystem()
    //let farm = new Farm()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class Milkfarm extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
  //farm!: Farm
  tabs = [
    { id: 'OfficeView', label: 'Office' },
    { id: 'PastureView', label: 'Pasture' },
    { id: 'LabView', label: 'Lab' }
  ]

  selectedTab: string = 'Menu'
}
</script>

<style lang="scss">
.page-grid {
  margin: auto;
  max-width: 1400px;
  height: 87vh;
  max-height: 800px;

  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "t s"
    "h s";

  @media screen and (max-width: $mobile-width){
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
      "s"
      "t"
      "h";

    //max-height: 100vh;
  }
}

.farm-window {
  border: $component-border-style;
  background-color: rgba($component-base-color, 1);
  padding: 10px;
  line-height: 1.4em;

  h1, h2, h3, h4, h5, p {
    margin-top: 0;
    margin-bottom: 10px;
  }
}

.farm-list-card {
  box-sizing: border-box;
  flex-direction: column;
  min-height: 200px;
  max-width: 700px;
  max-height: 100%;
  margin: 0 auto;
  padding: 10px;

  display: grid;
  grid-template-rows: 30px auto;
  grid-template-columns: auto 50px;
  grid-template-areas:
    "t x"
    "c c";
  grid-gap: 10px;

  h2 {
    margin: 0;
    line-height: 100%;
  }

  @media screen and (max-width: $mobile-width){
    padding: 10px;
    margin: 0 auto;
  }
}

.disabled-window {
  background-color: #333;
  color: #999;

  &:hover {
    cursor: default;
    color: #999 !important;
    border-color: black !important;
  }
}

.farm-list {
  @extend .farm-window;

  background-color: $component-background-color;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  & > h1, h2, h3, h4, h5, p {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.farm-list-entry {
  margin-bottom: 5px;
  flex-shrink: 0;
}

.farm-button {
  background-color: $component-button;

  transition: background-color $selection-time;

  &:hover {
    background-color: scale-color(lighten($component-button, 10%), $saturation: 30%);
  }
  &:active {
    background-color: scale-color(darken($component-button, 5%), $saturation: -5%);
  }
}

.exit-button {
  background-color: #8D141E;
  display: grid;

  &:hover {
    background-color: scale-color(lighten(#8D141E, 10%), $saturation: 30%);
  }
  &:active {
    background-color: scale-color(darken(#8D141E, 5%), $saturation: -5%);
  }

  h1, h2, h3, h4, p {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.disabled-button {
  background: $component-button-disabled;
  cursor: default !important;
  color: #999 !important;

  &:hover {
    background-color: $component-button-disabled;
  }

  &:active {
    background-color: $component-button-disabled;
  }
}

.no-selected {
  background-color: $component-background-color;
  border: $component-border-style;
  height: 450px;

  display: grid;
  grid-template-rows: 1fr;

  h1 {
    margin-top: auto;
    margin-bottom: auto;
    text-align: center;
  }
}

.status-card {
  width: 1fr;
}

</style>

<style scoped lang="scss">
  .milkfarm {
    min-width: 360px;
    min-height: 100%;
    background-size: cover;
    background-attachment: fixed;
  }

  .value-meter {
    height: 50px;
    background-color: #222;

    .milk-label {
      margin: 0;
      mix-blend-mode: exclusion;
      color: #fff;
      font-weight: bold;
    }
  }

  .menu {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fit, 1fr);
    grid-template-rows: 100%;

    margin-bottom: 10px;
    text-align: center;
  }

  .tab {
    border-right: 1px solid black;
    background-color: rgba($component-base-color, 0.5);
    border-bottom: 1px solid black;
    transition: background-color $selection-time;
    height: 10vh;

    &:last-child {
      border-right: 0;
    }

    display: table;
    div {
      display: table-cell;
      vertical-align: middle;
    }
    & > h1 {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }

    &:hover {
      background-color: rgba($component-base-color, 0.25);
    }

    @media (max-width: $mobile-width) {
      font-size: 0.75em;
    }
  }

  .menu-tab {
    background-color: rgba(#541A32, 1);
    border-bottom: 1px solid black;

    &:hover {
      background-color: rgba(#541A32, 0.75);
    }
  }

  .selected-tab {
    background-color: rgba(0, 0, 0, 0);
    cursor: default;
    border-bottom: 0;

    &:hover {
      background-color: rgba(0, 0, 0, 0);
    }

    &:active {
      background-color: rgba(0, 0, 0, 0);
    }
  }

  $disabled-color: adjust-color(rgba($component-base-color, 0.5), $saturation: -50%);
  .disabled-tab {
    background: $disabled-color;
    cursor: default;
    border-right: 0;

    h1 {
      visibility: hidden;
    }

    &:hover {
      background-color: $disabled-color;
    }

    &:active {
      background-color: $disabled-color;
    }
  }
</style>
